import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConfig, AppConfigService } from './app-config.service';

@Injectable()
export class PaidVersionGuard {
  constructor(private appConfig: AppConfigService) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.appConfig.appConfig.pipe(
      map((config: AppConfig) => {
        return config.isPaidVersion;
      }),
    );
  }
}
